/**
 * Converts a value to a number. An empty value gives null, so that 0 stays an explicit user value (TAC2-2004).
 */
export function toNullableNumber(value: string | number | null | undefined): number | null {
  return value === null || value === undefined || value === '' ? null : Number(value);
}
